import { render, staticRenderFns } from "./pdfDisplay.vue?vue&type=template&id=032cb801&scoped=true&lang=pug&"
import script from "./pdfDisplay.vue?vue&type=script&lang=js&"
export * from "./pdfDisplay.vue?vue&type=script&lang=js&"
import style0 from "./pdfDisplay.vue?vue&type=style&index=0&id=032cb801&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "032cb801",
  null
  
)

export default component.exports